module.exports = __webpack_public_path__ + "static/media/quienes-somos.709e0251.jpg";